import script from "./TermsAgreementSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAgreementSection.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAgreementSection.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__